<template>
  <el-card shadow="never" class="card">
    <!-- 顶部区域 -->
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
      <div style="display: flex; align-items: center;">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="query.keyword"
              placeholder="请输入群名称或者员工编号"
              clearable
              style="width: 300px;"
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-form>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="openCreateDialog">新增</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <el-table
      v-loading="loading"
      :data="list"
      style="width: 100%;border:1px solid #dfe6ec;"
      header-cell-style="background-color: #f5f7fb; text-align: center;"
      cell-style="text-align: center;"
    >
      <el-table-column label="企业名称">
        <template slot-scope="scope">
          {{ scope.row.corp_name || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="员工编号">
        <template slot-scope="scope">
          {{ scope.row.employee_no || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="员工名称">
        <template slot-scope="scope">
          {{ scope.row.corp_user_name || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="群名称">
        <template slot-scope="scope">
          {{ scope.row.group_chat_name || '--' }}
        </template>
      </el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="2"
            active-text="开启"
            inactive-text="关闭"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>

      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.created_at_text || formatTime(scope.row.created_at) || '--' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="margin-top: 20px; text-align: right;">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="query.page_size"
        :current-page.sync="query.page"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 新增弹窗 -->
    <el-dialog title="新增员工名片群" :visible.sync="dialogVisible" width="800px">
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <!-- 群选择 -->
        <el-form-item label="群" prop="group_chat_id">
          <div v-if="form.selectedGroup">
            <el-tag
              closable
              style="margin-right: 10px;"
              @close="removeGroup"
            >
              {{ form.selectedGroup.group_chat_name || form.selectedGroup.name }}
            </el-tag>
            <el-button type="text" @click="openSelectGroupDialog">重新选择</el-button>
          </div>
          <div v-else>
            <el-button type="primary" @click="openSelectGroupDialog">选择群</el-button>
          </div>
        </el-form-item>

        <!-- 员工选择 -->
        <el-form-item label="员工" prop="employee_nos">
          <div
            v-if="selectedEmployees && selectedEmployees.length"
            style="max-height: 150px; overflow-y: auto; margin-bottom: 10px; padding: 5px; border: 1px solid #dcdfe6; border-radius: 4px;"
          >
            <el-tag
              v-for="(emp, index) in selectedEmployees"
              :key="index"
              closable
              style="margin-right: 10px; margin-bottom: 10px;"
              @close="removeEmployee(index)"
            >
              {{ emp.name }}（{{ emp.employee_no }}）
            </el-tag>
          </div>
          <el-button type="primary" @click="openSelectEmployeeDialog">选择员工</el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 群选择弹窗 -->
    <el-dialog title="选择群" :visible.sync="selectGroupDialogVisible" width="1000px">
      <div style="margin-bottom: 20px; display: flex; gap: 10px; align-items: center;">
        <span style="width: 60px;">企业：</span>
        <el-autocomplete
          v-model="groupSearchCorpName"
          :fetch-suggestions="queryCorpSearch"
          placeholder="请输入企业名称"
          clearable
          style="width: 250px;"
          @select="handleCorpSelect"
          @clear="handleCorpClear"
        />
        <span style="width: 60px; margin-left: 10px;">群名称：</span>
        <el-input
          v-model="groupSearchKeyword"
          placeholder="请输入群名检索"
          clearable
          style="width: 250px;"
          :disabled="!groupSearchCorpId"
          @keyup.enter.native="handleSearchGroup"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          :disabled="!groupSearchCorpId"
          @click="handleSearchGroup"
        >
          搜索
        </el-button>
      </div>

      <el-table
        v-loading="loadingGroup"
        :data="groupChatList"
        style="width: 100%;"
        @row-click="selectGroup"
      >
        <el-table-column prop="group_chat_name" label="群名称" min-width="150" align="center" />
        <el-table-column prop="member_num" label="成员数量" width="80" align="center" />
        <el-table-column prop="group_chat_owner" label="群主" min-width="200" align="center" />
        <el-table-column label="创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.group_chat_create_time || scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="selectGroup(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px; text-align: right;">
        <el-pagination
          v-if="groupTotal > 0 || groupChatList.length > 0"
          background
          layout="total, prev, pager, next, jumper"
          :total="groupTotal"
          :page-size="groupSearch.pageSize"
          :current-page.sync="groupSearch.page"
          @current-change="handleGroupPageChange"
        />
      </div>
    </el-dialog>

    <!-- 员工选择弹窗 -->
    <el-dialog title="选择员工" :visible.sync="selectEmployeeDialogVisible" width="1000px">
      <div style="margin-bottom: 20px; display: flex; gap: 10px;">
        <el-input
          v-model="employeeSearch.keywords"
          placeholder="请输入员工名称/编号"
          clearable
          style="width: 250px;"
          @keyup.enter.native="handleSearchEmployee"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleSearchEmployee">搜索</el-button>
      </div>

      <el-table
        ref="employeeTable"
        v-loading="loadingEmployee"
        :data="employeeCandidates"
        style="width: 100%;"
        @selection-change="handleEmployeeSelectionChange"
        @row-click="handleEmployeeRowClick"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="corp_name" label="企业" />
        <el-table-column prop="employee_no" label="员工编号" />
      </el-table>

      <div style="margin-top: 20px; text-align: right;">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="employeeTotal"
          :page-size="employeeSearch.pageSize"
          :current-page.sync="employeeSearch.page"
          @current-change="handleEmployeePageChange"
        />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="selectEmployeeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSelectEmployees">确认选择</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  employeeBusinessCardGroupList,
  businessGroupChatList,
  filterCorpList,
  spCorpcorpUsersList,
  employeeBusinessCardGroupCreate,
  employeeBusinessCardGroupUpdate
} from '@/api/employeeBusinessCardGroup'

export default {
  name: 'EmployeeBusinessCardGroup',
  data() {
    return {
      query: {
        keyword: '',
        page: 1,
        page_size: 10
      },
      list: [],
      total: 0,
      loading: false,

      // 新增弹窗
      dialogVisible: false,
      form: {
        group_chat_id: '',
        selectedGroup: null,
        employee_nos: []
      },
      rules: {
        group_chat_id: [{ required: true, message: '请选择群', trigger: 'change' }],
        employee_nos: [{ required: true, message: '请选择员工', trigger: 'change' }]
      },

      // 企业列表
      corpList: [],

      // 群选择弹窗
      selectGroupDialogVisible: false,
      groupSearchCorpId: '',
      groupSearchCorpName: '',
      groupChatList: [],
      groupSearchKeyword: '',
      loadingGroup: false,
      groupSearch: {
        page: 1,
        pageSize: 10
      },
      groupTotal: 0,

      // 员工选择弹窗
      selectEmployeeDialogVisible: false,
      employeeSearch: {
        keywords: '',
        page: 1,
        pageSize: 10
      },
      employeeCandidates: [],
      employeeTotal: 0,
      loadingEmployee: false,
      selectedEmployees: [],
      tempSelectedEmployees: [] // 临时选中的员工
    }
  },
  created() {
    this.fetchList()
    this.fetchCorpList()
  },
  methods: {
    // 列表相关
    async fetchList() {
      this.loading = true
      try {
        const res = await employeeBusinessCardGroupList(this.query)
        this.list = res.data.list || []
        this.total = res.data.total || 0
      } catch (e) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(ts) {
      if (!ts) return '--'
      const date = new Date(ts * 1000)
      const Y = date.getFullYear()
      const M = String(date.getMonth() + 1).padStart(2, '0')
      const D = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    handleSearch() {
      this.query.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.query.page = page
      this.fetchList()
    },

    // 状态开关
    async handleStatusChange(row) {
      const newStatus = row.status
      const oldStatus = newStatus === 1 ? 2 : 1
      try {
        await employeeBusinessCardGroupUpdate({
          employee_no: row.employee_no,
          group_chat_id: row.group_chat_id,
          status: newStatus
        })
        this.$message.success('状态已更新')
      } catch (e) {
        // 如果失败，恢复原状态
        this.$set(row, 'status', oldStatus)
        this.$message.error('状态更新失败')
      }
    },

    // 新增弹窗
    openCreateDialog() {
      this.dialogVisible = true
      this.form = {
        group_chat_id: '',
        selectedGroup: null,
        employee_nos: []
      }
      this.selectedEmployees = []
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    // 企业列表
    async fetchCorpList() {
      try {
        const res = await filterCorpList({})
        this.corpList = res.data.list || res.data || []
      } catch (e) {
        console.error('获取企业列表失败', e)
      }
    },

    // 群选择弹窗
    openSelectGroupDialog() {
      this.selectGroupDialogVisible = true
      this.groupSearchCorpId = ''
      this.groupSearchCorpName = ''
      this.groupSearchKeyword = ''
      this.groupSearch.page = 1
      this.groupChatList = []
      this.groupTotal = 0
    },
    // 企业自动完成搜索
    queryCorpSearch(queryString, cb) {
      const results = queryString
        ? this.corpList.filter(corp => {
          const corpName = (corp.corp_name || corp.name || '').toLowerCase()
          return corpName.includes(queryString.toLowerCase())
        })
        : this.corpList
      // 格式化数据，el-autocomplete 需要 value 字段
      const formattedResults = results.map(corp => ({
        value: corp.corp_name || corp.name,
        corp_id: corp.corp_id || corp.id,
        corp_name: corp.corp_name || corp.name
      }))
      cb(formattedResults)
    },
    handleCorpSelect(item) {
      this.groupSearchCorpId = item.corp_id
      this.groupSearchCorpName = item.value
      // 选择企业后，清空群列表和搜索关键词
      this.groupChatList = []
      this.groupSearchKeyword = ''
      this.groupSearch.page = 1
      this.groupTotal = 0
    },
    handleCorpClear() {
      this.groupSearchCorpId = ''
      this.groupSearchCorpName = ''
      this.groupChatList = []
      this.groupSearchKeyword = ''
      this.groupSearch.page = 1
      this.groupTotal = 0
    },
    async handleSearchGroup() {
      if (!this.groupSearchCorpId) {
        this.$message.warning('请先选择企业')
        return
      }
      this.loadingGroup = true
      try {
        const params = {
          corp_id: this.groupSearchCorpId,
          page: this.groupSearch.page,
          page_size: this.groupSearch.pageSize
        }
        if (this.groupSearchKeyword && this.groupSearchKeyword.trim() !== '') {
          params.chat_name = this.groupSearchKeyword.trim()
        }
        const res = await businessGroupChatList(params)
        this.groupChatList = res.data?.list || res.data?.data || res.data || []
        this.groupTotal = res.data?.total || res.data?.count || 0
      } catch (e) {
        console.error('获取群列表失败', e)
        this.$message.error('获取群列表失败')
      } finally {
        this.loadingGroup = false
      }
    },
    handleGroupPageChange(page) {
      this.groupSearch.page = page
      this.handleSearchGroup()
    },
    selectGroup(row) {
      this.form.selectedGroup = row
      this.form.group_chat_id = row.group_chat_id || row.id
      this.selectGroupDialogVisible = false
      this.$message.success(`已选择群：${row.name || row.group_chat_name}`)
    },
    removeGroup() {
      this.form.selectedGroup = null
      this.form.group_chat_id = ''
    },

    // 员工选择弹窗
    openSelectEmployeeDialog() {
      this.selectEmployeeDialogVisible = true
      this.employeeSearch = {
        keywords: '',
        page: 1,
        pageSize: 10
      }
      this.tempSelectedEmployees = [...this.selectedEmployees]
      this.fetchEmployeeList()
    },
    async fetchEmployeeList() {
      this.loadingEmployee = true
      try {
        const res = await spCorpcorpUsersList(this.employeeSearch)
        this.employeeCandidates = res.data.list || []
        this.employeeTotal = res.data.total || 0

        // 设置已选中的员工
        this.$nextTick(() => {
          if (this.$refs.employeeTable) {
            this.$refs.employeeTable.clearSelection()
            this.employeeCandidates.forEach(row => {
              const isSelected = this.tempSelectedEmployees.some(
                emp => emp.employee_no === row.employee_no
              )
              if (isSelected) {
                this.$refs.employeeTable.toggleRowSelection(row, true)
              }
            })
          }
        })
      } catch (e) {
        this.$message.error('获取员工列表失败')
      } finally {
        this.loadingEmployee = false
      }
    },
    handleSearchEmployee() {
      this.employeeSearch.page = 1
      this.fetchEmployeeList()
    },
    handleEmployeePageChange(page) {
      this.employeeSearch.page = page
      this.fetchEmployeeList()
    },
    handleEmployeeSelectionChange(selection) {
      // 获取当前页所有员工的编号
      const currentPageEmployeeNos = this.employeeCandidates.map(emp => emp.employee_no)

      // 移除当前页的所有员工（因为要重新设置）
      this.tempSelectedEmployees = this.tempSelectedEmployees.filter(
        emp => !currentPageEmployeeNos.includes(emp.employee_no)
      )

      // 添加当前页新选中的员工
      selection.forEach(emp => {
        this.tempSelectedEmployees.push(emp)
      })
    },
    handleEmployeeRowClick(row) {
      // 点击行时切换选中状态
      if (this.$refs.employeeTable) {
        const isSelected = this.tempSelectedEmployees.some(
          emp => emp.employee_no === row.employee_no
        )
        // 切换选中状态
        this.$refs.employeeTable.toggleRowSelection(row, !isSelected)
        // 手动触发 selection-change 事件，确保 tempSelectedEmployees 同步更新
        // 获取当前表格的选中状态
        const currentSelection = this.$refs.employeeTable.selection || []
        this.handleEmployeeSelectionChange(currentSelection)
      }
    },
    confirmSelectEmployees() {
      this.selectedEmployees = [...this.tempSelectedEmployees]
      this.form.employee_nos = this.selectedEmployees.map(emp => emp.employee_no)
      this.selectEmployeeDialogVisible = false
      this.$message.success(`已选择 ${this.selectedEmployees.length} 个员工`)
    },
    removeEmployee(index) {
      this.selectedEmployees.splice(index, 1)
      this.form.employee_nos = this.selectedEmployees.map(emp => emp.employee_no)
    },

    // 提交表单
    async submitForm() {
      this.$refs.form.validate(async(valid) => {
        if (!valid) return

        // 验证员工是否选择
        if (!this.selectedEmployees.length) {
          this.$message.warning('请选择员工')
          return
        }

        try {
          await employeeBusinessCardGroupCreate({
            group_chat_id: this.form.group_chat_id,
            employee_nos: this.selectedEmployees.map(emp => emp.employee_no)
          })
          this.$message.success('新增成功')
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error('新增失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.card {
  margin: 22px;
}
</style>

